<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Remove Account Link</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <table>
      <tr>
        <td class="pr-2">Primary Customer:</td>
        <td>
          <a [routerLink]="['/customers', customer.id.toString()]" target="_blank">
            {{ customer.first_name }} {{ customer.last_name }}
          </a>
        </td>
      </tr>
      <tr>
        <td class="pr-2">Linked Customer:</td>
        <td>
          <a [routerLink]="['/customers', relation.related_customer_id.toString()]" target="_blank">
            {{ relation.related_customer_first_name }} {{ relation.related_customer_last_name }}
          </a>
        </td>
      </tr>
      <tr>
        <td class="pr-2 pt-3">
          {{ relation.related_customer_first_name }}'s relation to {{ customer.first_name }}:
        </td>
        <td class="pt-3">
          {{ getRelationTypeDisplay(relation.relation) }}
        </td>
      </tr>
    </table>

    <table class="mt-4">
      <tr>
        <td class="pb-2 pr-3 align-top">Information:</td>
        <td class="pb-2">{{ orgConfigService.getOrganizationConfig().customer_facing_linking_instructions }}</td>
      </tr>
    </table>

    <div class="alert alert-danger mb-0 mt-3" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

  </div>

  <div class="modal-footer">

    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-danger"
            *ngIf="!loadingRemoveSubmit"
            (click)="handleRemoveSubmit()">
      Remove Link
    </button>
    <button type="button" class="btn btn-danger disabled" disabled
            *ngIf="loadingRemoveSubmit">
      Loading...
    </button>

  </div>

</ng-container>
